"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMethodMeta = void 0;
var error_messages_1 = require("../constants/error-messages");
var metadata_handler_1 = require("../metadata/metadata-handler");
/**
 * 给类的方法添加元数据
 * @param metaKey
 * @param metaData
 * @param target
 */
function addMethodMeta(metaKey, metaData, target) {
    // 获取target上的metadata
    if (metadata_handler_1.MetadataHandler.hasMetadata(metaKey, target)) {
        var oldMetaData = metadata_handler_1.MetadataHandler.getMethodMetadata(metaKey, target);
        // eslint-disable-next-line new-cap
        throw Error(error_messages_1.DUPLICATED_METHOD_METADATA(metaKey, oldMetaData === null || oldMetaData === void 0 ? void 0 : oldMetaData.methodName));
    }
    // 将函数名称保存到元数据里
    metadata_handler_1.MetadataHandler.setMethodMetadata(metaKey, metaData, target);
}
exports.addMethodMeta = addMethodMeta;
//# sourceMappingURL=add-method-meta.js.map